<i18n src="../../locales/lang.json"></i18n>



<template>
  <div style="position:relative">
    <div class="row">
      <div class="col pr-5 pr-0" id="test" style="z-index:3">
        <div ref="buttonContainer" class="pl-2 pl-md-0 pb-2" id="buttonContainer">
          <div class="dropdown dropright" style="margin:auto;z-index:1000;float:left;margin-right:0px;" id="initialButton">
            <button type="button" class="newplus-button btn p-0 m-0" style="border: 0; background-color: initial !important; box-shadow:none !important;" data-toggle="dropdown" data-display="static" aria-haspopup="true" aria-expanded="false">
              <img src="/Images/Filter_Black_100x100px.png" class="button-icon" />
            </button>

            <div class="skinnedmenu dropdown-menu" id="additemsmenu">

              <div class="dropdown-submenu" v-show="locations.length>0">
                <a href="#" class="dropdown-item dropdown-toggle" style="">{{ $store.translate('location')}}</a>
                <div class="skinnedmenu dropdown-menu mobile-submenu" style="position: relative;">
                  <div class="form-group form-group-feedback form-group-feedback-left mx-2 my-0">
                    <input type="text" class="form-control form-control" v-model="locationFilter" @input="filterLocations" placeholder="filter">
                    <div class="form-control-feedback form-control-feedback">
                      <i class="icon-search4"></i>
                    </div>
                  </div>
                  <a v-bind:style="getdisplay(menuItem)" v-on:click.prevent="addFilterButton('location',menuItem.id, menuItem.text)" class="dropdown-item" v-for="menuItem in locations">{{ menuItem.text }}</a>
                </div>
              </div>

              <div class="dropdown-submenu" v-show="shifts.length>0">
                <a href="#" class="dropdown-item dropdown-toggle" style="">{{$store.translate('shift')}}</a>
                <div class="skinnedmenu dropdown-menu mobile-submenu" style="position: relative;">
                  <div class="form-group form-group-feedback form-group-feedback-left mx-2 my-0">
                    <input type="text" class="form-control form-control" v-model="shiftFilter" @input="filterShifts" placeholder="filter">
                    <div class="form-control-feedback form-control-feedback">
                      <i class="icon-search4"></i>
                    </div>
                  </div>
                  <a v-bind:style="getdisplay(menuItem)" v-on:click.prevent="addFilterButton('siteshift',menuItem.id, menuItem.text)" class="dropdown-item" v-for="menuItem in shifts">{{ menuItem.text }}</a>
                </div>
              </div>


              <div class="dropdown-submenu" v-show="teams.length>0">
                <a href="#" style="" class="dropdown-item dropdown-toggle">{{$store.translate('team')}}</a>
                <div class="skinnedmenu dropdown-menu mobile-submenu" style="position:relative;">
                  <div class="form-group form-group-feedback form-group-feedback-left mx-2 my-0">
                    <input type="text" class="form-control form-control" v-model="teamFilter" @input="filterTeams" placeholder="filter">
                    <div class="form-control-feedback form-control-feedback">
                      <i class="icon-search4"></i>
                    </div>
                  </div>
                  <a v-bind:style="getdisplay(menuItem)" @click="addFilterButton('team',menuItem.id, menuItem.text)" class="dropdown-item" v-for="menuItem in teams">{{ menuItem.text }}</a>
                </div>
              </div>

              <div class="dropdown-submenu" v-show="projects.length>0">
                <a href="#" style="" class="dropdown-item dropdown-toggle">{{$store.translate('project')}}</a>
                <div class="skinnedmenu dropdown-menu mobile-submenu" style="position:relative;">
                  <div class="form-group form-group-feedback form-group-feedback-left mx-2 my-0">
                    <input type="text" class="form-control form-control" v-model="projectFilter" @input="filterProjects" placeholder="filter">
                    <div class="form-control-feedback form-control-feedback">
                      <i class="icon-search4"></i>
                    </div>
                  </div>
                  <a v-bind:style="getdisplay(menuItem)" @click="addFilterButton('project',menuItem.id, menuItem.text)" class="dropdown-item" v-for="menuItem in projects">{{ menuItem.text }}</a>
                </div>
              </div>

              <div class="dropdown-submenu">

                <a href="#" class="dropdown-item dropdown-toggle" @click="loadUsers">{{$t('user')}}</a>
                <div class="skinnedmenu dropdown-menu mobile-submenu" style="position: relative;">
                  <div class="form-group form-group-feedback form-group-feedback-left mx-2 my-0">
                    <input type="text" class="form-control form-control" v-model="userFilter" @input="filterUsers" placeholder="filter">
                    <div class="form-control-feedback form-control-feedback">
                      <i class="icon-search4"></i>
                    </div>
                  </div>
                  <a v-bind:style="getdisplay(menuItem)" @click="addFilterButton('user',menuItem.id, menuItem.text)" class="dropdown-item" v-for="menuItem in users">{{ menuItem.text }}</a>
                </div>


              </div>

              <!--<div class="dropdown-submenu">
    <a href="#" class="dropdown-item  dropdown-toggle">{{$t('status')}}</a>
    <div class="skinnedmenu dropdown-menu mobile-submenu" style="position: relative;">
      <a @click="addStatusFilterButton('created')" class="dropdown-item">{{$t('created')}}</a>
      <a @click="addStatusFilterButton('done')" class="dropdown-item">{{$t('done')}}</a>
      <a @click="addStatusFilterButton('notstatus')" class="dropdown-item">{{$t('not_done')}}</a>
      <a @click="addStatusFilterButton('closed')" class="dropdown-item">{{$t('closed')}}</a>
    </div>
  </div>
  <div class="dropdown-submenu" v-show="this.$store.getUserPermissionLevel() > 2">
    <a href="#" class="dropdown-item  dropdown-toggle">{{$t('priority')}}</a>
    <div class="skinnedmenu dropdown-menu mobile-submenu" style="position: relative;">
      <a @click="addPriorityFilterButton('low')" class="dropdown-item">{{$t('low')}}</a>
      <a @click="addPriorityFilterButton('medium')" class="dropdown-item">{{$t('medium')}}</a>
      <a @click="addPriorityFilterButton('high')" class="dropdown-item">{{$t('high')}}</a>
    </div>
  </div>-->
              <div class="dropdown-submenu">
                <a href="#" class="dropdown-item  dropdown-toggle">{{$t('date')}}</a>
                <div class="skinnedmenu dropdown-menu mobile-submenu" style="position: relative;">
                  <a @click="addDateFilterButton('today')" class="dropdown-item">{{$t('today')}}</a>
                  <a @click="addDateFilterButton('tomorrow')" class="dropdown-item">{{$t('tomorrow')}}</a>
                  <a @click="addDateFilterButton('lastweek')" class="dropdown-item">{{$t('lastweek')}}</a>
                  <a @click="addDateFilterButton('thisweek')" class="dropdown-item">{{$t('thisweek')}}</a>
                  <a @click="addDateFilterButton('nextweek')" class="dropdown-item">{{$t('nextweek')}}</a>
                  <a @click="addDateFilterButton('lastmonth')" class="dropdown-item">{{$t('lastmonth')}}</a>
                  <a @click="addDateFilterButton('thismonth')" class="dropdown-item">{{$t('thismonth')}}</a>
                  <a @click="addDateFilterButton('nextmonth')" class="dropdown-item">{{$t('nextmonth')}}</a>
                </div>
              </div>



              <div class="dropdown-submenu" v-show="this.$store.getUserPermissionLevel() > 4">
                <a href="#" class="dropdown-item dropdown-toggle" style="" @click="loadProcedures">{{$store.translate('template')}}</a>
                <div class="skinnedmenu dropdown-menu mobile-submenu" style="position: relative;">
                  <div class="form-group form-group-feedback form-group-feedback-left mx-2 my-0">
                    <input type="text" class="form-control form-control" v-model="procedureFilter" @input="filterProcedures" placeholder="filter">
                    <div class="form-control-feedback form-control-feedback">
                      <i class="icon-search4"></i>
                    </div>
                  </div>
                  <a v-bind:style="getdisplay(menuItem)" v-on:click.prevent="addFilterButton('procedure',menuItem.id, menuItem.text)" class="dropdown-item" v-for="menuItem in procedures">{{ menuItem.text }}</a>
                </div>
              </div>
              <div class="">
                <a href="#" class="dropdown-item" style="" @click="addFilterButton('newuser', '0','newuser')">{{$t('new_user')}}</a>
              </div>


              <!--<div class="" v-if="hideMyFilter===false && this.$store.getUserPermissionLevel() > 2">
    <a href="#" class="dropdown-item" style="" @click="saveInBrowser('getfromcookie')">{{$t('my_filter')}}</a>
  </div>
  <div class="" v-if="hideSaveFilter===false && this.$store.getUserPermissionLevel() > 2">
    <a href="#" class="dropdown-item" style="" @click="saveInBrowser('savecookie')">{{$t('save_filter_inbrowser')}}</a>
  </div>-->
            </div>
          </div>
        </div>
      </div>

    </div>
    <div v-show="configurators.length > 0" class="row mt-3">
      <div class="col">
        <div id="childComponentContainer" ref="childComponentContainer"></div>
      </div>
    </div>

  </div>




</template>

<script>

  var activated = false;

  import FilterButton from './filter-button.vue'
  import ConfigUser from './configurators/config-user.vue'
  import ConfigContact from './configurators/config-contact.vue'
  import ConfigTeam from './configurators/config-team.vue'
  import ConfigPriority from './configurators/config-priority.vue'
  import ConfigLocation from './configurators/config-location.vue'
  import ConfigDate from './configurators/config-date.vue'
  import ConfigOrganisation from './configurators/config-organisation.vue'

  import DisplayUser from './displayers/display-user.vue'
  import DisplayUserTaskstatus from './displayers/display-user-taskstatus.vue'
  import DisplayUserTime from './displayers/display-user-time.vue'

  import DisplayContact from './displayers/display-contact.vue'
  import DisplayTeam from './displayers/display-team.vue'
  import DisplayTeamWorkload from './displayers/display-team-workload.vue'
  import DisplayTeamTaskstatus from './displayers/display-team-taskstatus.vue'
  import DisplayTeamTime from './displayers/display-team-time.vue'
  import DisplayPriority from './displayers/display-priority.vue'
  import DisplayLocation from './displayers/display-location.vue'
  import DisplayDate from './displayers/display-date.vue'
  import DisplayOrganisation from './displayers/display-organisation.vue'
  import moment from 'moment'

  var user = "";
  var configurators = [];
  var buttons = [];
  var displayers = [];
  var locations = [];
  var shifts = [];

  var users = [];
  var teams = [];
  var projects = [];
  var procedures = [];
 
  var locationFilter = "";
  var shiftFilter = "";
 
  var userFilter = "";
  var teamFilter = "";
  var organisationFilter = "";
  var procedureFilter = "";
  var projectFilter = "";

  export default {
    name: "filter-container-mini",
    components: {
      FilterButton,
      ConfigUser,
      ConfigTeam,
      ConfigPriority,
      ConfigLocation,
      ConfigDate,
      ConfigOrganisation,
      ConfigContact,

      DisplayUser,
      DisplayContact,
      DisplayTeam,
      DisplayTeamWorkload,
      DisplayTeamTaskstatus,
      DisplayTeamTime,
      DisplayPriority,
      DisplayLocation,
      DisplayDate,
      DisplayOrganisation,
    },
    props: {
      enableedit: {
        required: false,
        type: String,
        default: "false"
      },
      user: {
        type: String,
        default: ""
      },
      defaultdisplay: {
        type: Number,
        default: 9
      },
      hideMyFilter: {
        required: false,
        type: Boolean,
        default: false
      },
      hideSaveFilter: {
        required: false,
        type: Boolean,
        default: false
      },      
    },
    data() {
      return {
        activated,
        configurators,
        buttons,
        displayers,
        locations,
        shifts,
       
        procedures,
        
        users,
        teams,
        projects,
        locationFilter,
       
        userFilter,
        teamFilter,
        projectFilter,
      };
    },

    methods: {
      toggleActivation() {
        this.activated = !this.activated
      },
      handleRefresh(val) {
        this.loadLocations();
        this.loadTeams();
        this.loadShifts();
        this.loadProjects();
        this.$forceUpdate();
      }
      ,
      addConfigurator(type) {

        var ComponentClass = null;
        if (type == "user") {
          ComponentClass = Vue.extend(ConfigUser);
        }
        else if (type == "contact") {
          ComponentClass = Vue.extend(ConfigContact);
        }
        else if (type == "location") {
          ComponentClass = Vue.extend(ConfigLocation);
        }
        else if (type == "team") {
          ComponentClass = Vue.extend(ConfigTeam);
        }
        else if (type == "priority") {
          ComponentClass = Vue.extend(ConfigPriority);
        }
        else if (type == "date") {
          ComponentClass = Vue.extend(ConfigDate);
        }
        else if (type == "organisation") {
          ComponentClass = Vue.extend(ConfigOrganisation);
        }
        if (!this.hasElementOfType(this.configurators, type)) {
          //var instance = new ComponentClass({ propsData: { type: type } })
          if (type == "organisation") {
            var instance = new ComponentClass({ propsData: { type: type, user: this.user } })
          }
          else {
            var instance = new ComponentClass({ propsData: { type: type } })
          }
          instance.$mount();
          instance.$on('remove', this.removeItem);
          instance.$on('remove', function (id) {
            instance.$el.remove();
          });
          instance.$on('addFilter', this.addButton);
          this.configurators.push({ id: instance.$el.id, type: type });
          this.$refs.childComponentContainer.appendChild(instance.$el);
        }
      },
      removeItem(id) {
        for (var i = 0; i < this.configurators.length; i++) {
          if (this.configurators[i].id == id) {
            this.configurators.splice(i, 1);
          }
        }
      },
      removeDisplayer(id) {
        for (var i = 0; i < this.displayers.length; i++) {
          if (this.displayers[i].id == id) {
            this.displayers.splice(i, 1);
          }
        }
      },
      addDisplayer(type, config, command) {

        var ComponentClass = null;

        if (command != null) {

          if (type == 'team') {
            if (command == 'allusers') {
              this.loadTeamUsers(config.data);
              return;
            }
            else if (command == 'teamtaskstatus') {
              ComponentClass = Vue.extend(DisplayTeamTaskstatus);
            }
            else if (command == 'teamtime') {
              ComponentClass = Vue.extend(DisplayTeamTime);
            }
            else if (command == 'teamworkload') {
              ComponentClass = Vue.extend(DisplayTeamWorkload);
            }
            else if (command == 'manageteam') {
              ComponentClass = Vue.extend(DisplayTeam);
            }
          }
          else if (type == 'user') {
            if (command == 'usertaskstatus') {
              ComponentClass = Vue.extend(DisplayUserTaskstatus);
            }
            else if (command == 'usertime') {
              ComponentClass = Vue.extend(DisplayUserTime);
            }
            else {
              ComponentClass = Vue.extend(DisplayUser);
            }
          }

          else {
            return;
          }
        }
        else {
          if (type == "user") {
            ComponentClass = Vue.extend(DisplayUser);
          }
          else if (type == "contact") {
            ComponentClass = Vue.extend(DisplayContact);
          }
          //else if (type == "location") {
          //  ComponentClass = Vue.extend(DisplayLocation);
          //}
          else if (type == "team") {
            ComponentClass = Vue.extend(DisplayTeam);
          }
          else if (type == "priority") {
            ComponentClass = Vue.extend(DisplayPriority);
          }
          //else if (type == "date") {
          //  ComponentClass = Vue.extend(DisplayDate);
          //}
          else if (type == "organisation") {
            ComponentClass = Vue.extend(DisplayOrganisation);
          }
        }

        //if (!this.hasElementOfType(this.displayers, type)) {
        var instance = new ComponentClass({ propsData: { type: type } })
        instance.setConfig(config);
        instance.$mount();
        instance.$on('remove', this.removeDisplayer);
        instance.$on('remove', function (id) {
          instance.$el.remove();
        });

        instance.$on('addFilter', this.addButton);
        this.displayers.push({ id: instance.$el.id, type: type });
        this.$refs.childComponentContainer.appendChild(instance.$el);
        //}

        if (typeof (instance.rendered) != "undefined") {
          instance.rendered();
        }


      },
      removeButton(id) {
        for (var i = 0; i < this.buttons.length; i++) {
          if (this.buttons[i].id == id) {
            this.buttons.splice(i, 1);
            //alert('doSearch14')
            //vm.$root.$emit('doFilterSearch');
          }
        }
      },

      addButton(type, config, dosearch) {
        var ComponentClass = Vue.extend(FilterButton)
        var instance = new ComponentClass({
          propsData: {
            type: type
          }
        })
        instance.config = config;
        instance.$mount();
        instance.$on('remove', this.removeButton);

        instance.$on('remove', function (id) {
          instance.$el.remove();
          //alert('doSearch15')
          vm.$root.$emit('doFilterSearch');
        });
        instance.$on('activate', this.addDisplayer);
        this.$refs.buttonContainer.appendChild(instance.$el);

        var length = this.buttons.length;
        for (var i = 0; i < length; i++) {
          var btn = this.buttons[i];
          if (btn !== null && btn.type === "date" && type === "date") {
            $('#' + btn.id).remove();
            this.removeButton(btn.id);
          }
        }

        this.buttons.push({ id: instance.$el.id, type: type, config: config });

        if (dosearch == null) {
          //alert('doSearch16')
          vm.$root.$emit('doFilterSearch');
        }

        App.initComponents();
      },
      saveInBrowser(action) {
        var obj = { action: action };
        var data = JSON.stringify(obj);
        //alert('doSearch17')
        vm.$root.$emit('doFilterSearch', data);
      },
      hasElementOfType(array, type) {
        var hasElementOfType = false;
        for (var i = 0; i < array.length; i++) {
          if (array[i].type == type) {
            hasElementOfType = true;
          }
        }
        return hasElementOfType;
      },
      getCurrentFilter() {
        return this.buttons;
      },
      clearFilters() {

        var children = $('#buttonContainer').children()
        for (var i = 1; i < children.length; i++) {
          children[i].remove()
        }
        this.buttons = [];
      },
      async loadLocations() {
        try {
          this.items = [];
          this.$http.get('/api/Locations/v1?').then(async response => {
            this.locations = [];

            if (response.data !== null && response.data.length > 0) {
              response.data = response.data.sort(function (a, b) {
                var x = a.locationname.toLowerCase();
                var y = b.locationname.toLowerCase();
                return x < y ? -1 : x > y ? 1 : 0;
              });
            }

            for (var i = 0; i < response.data.length; i++) {
              var loc = response.data[i];
              if (loc.ParentId === null) {
                //var childLocs = response.data.filter(n => n.ParentId == loc.locationid);
                var parentIds = loc.locationid;
                //childLocs.forEach(subloc => {
                //  parentIds = parentIds + ',' + subloc.locationid;
                //});
                this.locations.push({ id: parentIds, text: loc.locationname, display: true })

                //childLocs.forEach(subloc => {
                //  subloc.locationname = loc.locationname + ' > ' + subloc.locationname;
                //  this.locations.push({ id: subloc.locationid, text: subloc.locationname, display: true })
                //});
              }
            }
            this.filterLocations();
          });
        } catch (err) {
          alert('some error:' + err)
        }
      },
      async loadShifts() {
        try {
          this.items = [];
          this.$http.get('/api/Admin/v1/SiteShifts').then(async response => {
            this.shifts = [];

            if (response.data !== null && response.data.length > 0) {
              response.data = response.data.sort(function (a, b) {
                var x = a.Name.toLowerCase();
                var y = b.Name.toLowerCase();
                return x < y ? -1 : x > y ? 1 : 0;
              });
            }

            for (var i = 0; i < response.data.length; i++) {
              this.shifts.push({ id: response.data[i].SiteShiftId, text: response.data[i].Name, display: true })
            }
            this.filterShifts();
          });
        } catch (err) {
          alert('some error:' + err)
        }
      },
     
      async loadUsers() {
        try {
          this.$http.get('/api/Users/v1?').then(async response => {
            this.users = [];

            if (response.data !== null && response.data.length > 0) {
              response.data = response.data.sort(function (a, b) {
                var x = a.Name.toLowerCase();
                var y = b.Name.toLowerCase();
                return x < y ? -1 : x > y ? 1 : 0;
              });
            }

            for (var i = 0; i < response.data.length; i++) {
              this.users.push({ id: response.data[i].UserName, text: response.data[i].Name, display: true })
            }
            this.filterUsers();
          });
        } catch (err) {
          alert('some error:' + err)
        }
      },
      async loadProjects() {
        try {
          this.items = [];
          this.$http.get('/api/Projects/v1').then(async response => {
            this.projects = [];

            //if (response.data !== null && response.data.length > 0) {
            //  response.data = response.data.sort(function (a, b) {
            //    var x = a.Name.toLowerCase();
            //    var y = b.Name.toLowerCase();
            //    return x < y ? -1 : x > y ? 1 : 0;
            //  });
            //}

            for (var i = 0; i < response.data.length; i++) {
              this.projects.push({ id: response.data[i].ProjectId, text: response.data[i].Name, display: true, shiftTypeId: response.data[i].ShiftTypeId })
            }
            this.filterProjects();
          });
        } catch (err) {
          alert('some error:' + err)
        }
      },
      filterProjects() {
        var visibleItems = 0;
        for (var i = 0; i < this.projects.length; i++) {
          if ((this.projectFilter != null && this.projectFilter != "" && this.projects[i].text.toLowerCase().indexOf(this.projectFilter.toLowerCase()) == -1) || visibleItems > this.defaultdisplay) {
            this.projects[i].display = false;
          }
          else {
            this.projects[i].display = true;
            visibleItems++;
          }
        }
        Vue.set(this, "projects", this.projects);
      },
      async loadTeams() {
        try {
          this.$http.get('/api/Teams/v1?').then(async response => {
            this.teams = [];

            if (response.data !== null && response.data.length > 0) {
              response.data = response.data.sort(function (a, b) {
                var x = a.Name.toLowerCase();
                var y = b.Name.toLowerCase();
                return x < y ? -1 : x > y ? 1 : 0;
              });
            }

            for (var i = 0; i < response.data.length; i++) {
              this.teams.push({ id: response.data[i].Id, text: response.data[i].Name, display: true })
            }
            this.filterTeams();
          });
        } catch (err) {
          alert('some error:' + err)
        }
      },
      
     
      async loadProcedures() {
        try {
          this.$http.get('/api/Procedures/v1/GetProcedures?').then(async response => {
            this.procedures = [];

            if (response.data !== null && response.data.length > 0) {
              response.data = response.data.sort(function (a, b) {
                var x = a.Name.toLowerCase();
                var y = b.Name.toLowerCase();
                return x < y ? -1 : x > y ? 1 : 0;
              });
            }

            for (var i = 0; i < response.data.length; i++) {
              this.procedures.push({ id: response.data[i].Id, text: response.data[i].Name, display: true })
            }
            this.filterProcedures()
          });
        } catch (err) {
          alert('some error:' + err)
        }
      },
      
      addPriorityFilterButton(type) {
        var data = "";
        var text = "";
        var abbreviation = null;
        var cssIcon = null;
        var filtertype = null;
        var customstyle = "background-color:rgba(131, 189, 166, 0.8)"
        var color = "rgba(131, 189, 166, 0.8)";
        if (type == 'low') {
          color = "rgba(239, 193, 101, 0.8)";
          filtertype = "priority"
          data = 0;
          text = this.$t('priority_low');
          customstyle = "background-color:rgba(239, 193, 101, 0.8)";
          cssIcon = "icon-stack-star icon-2x";
        }
        else if (type == 'medium') {
          color = "rgba(239, 193, 101, 0.8)";
          filtertype = "priority"
          data = 1;
          text = this.$t('priority_medium');
          customstyle = "background-color:rgba(239, 193, 101, 0.8)",
            cssIcon = "icon-stack-check icon-2x";
        }
        else if (type == 'high') {
          color = "rgba(235, 90, 70, 0.8)";
          filtertype = "priority"
          data = 2;
          text = this.$t('priority_high');
          customstyle = "background-color:rgba(235, 90, 70, 0.8)";
          cssIcon = "icon-stack-cancel icon-2x";
        }
        var buttonData =
        {
          color: color,
          customstyle: customstyle,
          customclass: "",
          abbreviation: abbreviation,
          data: data,
          text: text,
          icon: null,
          cssIcon: cssIcon
        };

        this.addButton(filtertype, buttonData);

      },
      addStatusFilterButton(type) {
        var data = "";
        var text = "";
        var abbreviation = null;
        var cssIcon = null;
        var filtertype = null;
        var customstyle = "background-color:rgba(131,189,166,0.8)"
        var color = "rgba(131,189,166,0.8)"

        if (type == 'created') {
          color = "rgba(239, 193, 101, 0.8)";
          filtertype = "status"
          data = 0;
          text = this.$t('created');
          customstyle = "background-color:rgba(239, 193, 101, 0.8)";
          cssIcon = "icon-stack-star icon-2x";
        }
        else if (type == 'done') {
          color = "rgba(131,189,166,0.8)";
          filtertype = "status"
          data = 2;
          text = this.$t('done');
          customstyle = "background-color:rgba(131,189,166,0.8)",
            cssIcon = "icon-stack-check icon-2x";
        }
        else if (type == 'notstatus') {
          color = "rgba(237,125,49,0.8)";
          filtertype = "notstatus"
          data = 2;
          text = this.$t('not_done');
          customstyle = "background-color:rgba(237,125,49,0.8)";
          cssIcon = "icon-stack-cancel icon-2x";
        }
        else if (type == 'closed') {
          color = "rgba(255,0,0,0.8)";
          filtertype = "status"
          data = 4;
          text = this.$t('closed');
          customstyle = "background-color:rgba(255,0,0,0.8)",
            cssIcon = "icon-stack-check icon-2x";
        }
        var buttonData =
        {
          color: color,
          customstyle: customstyle,
          customclass: "",
          abbreviation: abbreviation,
          data: data,
          text: text,
          icon: null,
          cssIcon: cssIcon
        };

        this.addButton(filtertype, buttonData);

      },

      addDateFilterButton(type) {
        var data = "";
        var startDate = null;
        var endDate = null;
        var text = "";
        var abbreviation = "";
        var cssIcon = null;
        var color = "";

        if (type == 'today') {
          startDate = moment();//.add(-1, 'days');
          endDate = moment();
          abbreviation = endDate.format('D');
          text = endDate.format('MMM');
        }
        else if (type == 'tomorrow') {
          startDate = moment().add(1, 'days').endOf('day');//moment().endOf('day');
          endDate = moment().add(1, 'days').endOf('day');
          abbreviation = endDate.format('D');
          text = endDate.format('MMM');
        }
        else if (type == 'lastweek') {
          startDate = moment().subtract(1, 'weeks').startOf('week');
          endDate = moment().subtract(1, 'weeks').endOf('week');
          abbreviation = null;
          text = startDate.format('D') + " " + startDate.format('MMM') + "-" + endDate.format('D') + " " + endDate.format('MMM');
          cssIcon = "icon-calendar2 icon-2x"
        }
        else if (type == 'thisweek') {
          startDate = moment().startOf('week');
          endDate = moment().endOf('week');
          abbreviation = null;
          text = startDate.format('D') + " " + startDate.format('MMM') + "-" + endDate.format('D') + " " + endDate.format('MMM');
          cssIcon = "icon-calendar2 icon-2x"
        }
        else if (type == 'nextweek') {
          startDate = moment().add(1, 'weeks').startOf('week');
          endDate = moment().add(1, 'weeks').endOf('week');
          abbreviation = null;
          text = startDate.format('D') + " " + startDate.format('MMM') + "-" + endDate.format('D') + " " + endDate.format('MMM');
          cssIcon = "icon-calendar2 icon-2x"
        }
        else if (type == 'lastmonth') {
          startDate = moment().subtract(1, 'months').startOf('month');
          endDate = moment().subtract(1, 'months').endOf('month');
          abbreviation = null;
          text = endDate.format('MMM');
          cssIcon = "icon-calendar2 icon-2x"
        }
        else if (type == 'thismonth') {
          startDate = moment().startOf('month');
          endDate = moment().endOf('month');
          abbreviation = null;
          text = endDate.format('MMM');
          cssIcon = "icon-calendar2 icon-2x"
        }
        else if (type == 'nextmonth') {
          startDate = moment().add(1, 'months').startOf('month');
          endDate = moment().add(1, 'months').endOf('month');
          abbreviation = null;
          text = endDate.format('MMM');
          cssIcon = "icon-calendar2 icon-2x"
        }
        else if (type == 'custom') {

        }

        data = startDate.format('YYYY-MM-DD') + "," + endDate.format('YYYY-MM-DD');

        var buttonData =
        {
          color: "rgba(122,176,197,0.8)",
          customstyle: "background-color:rgba(122,176,197,0.8)",
          customclass: "",
          abbreviation: abbreviation,
          data: data,
          text: text,
          icon: null,
          cssIcon: cssIcon
        };

        this.addButton('date', buttonData);

      },
      
      addFilterButton(type, data, text) {

        var bgStyle = "";
        var icon = null;
        var menu = null;
        var color = "";

        if (type == "location") {
          color = "rgba(218,224,215,0.8)";
          bgStyle = "background-color:rgba(218,224,215,0.8)";
          //icon = "/images/filter_icons/icon-location.png";
        }
        else if (type == "shift") {
          color = "rgba(100,224,215,0.8)";
          bgStyle = "background-color:rgba(100,224,215,0.8)";
          //icon = "/images/filter_icons/icon-location.png";
        }
        else if (type == "user") {
          color = "rgba(239,193,101,0.8)";
          bgStyle = "background-color:rgba(239,193,101,0.8)";
          //menu = [{ text: 'User location', command: 'allusers' }, { text: 'User task status', command: 'usertaskstatus' }, { text: 'User time done', command: 'usertime' }]
        }
        else if (type == "team") {
          // alert("data:" + data)
          color = "rgba(200,228,143,0.8)";
          bgStyle = "background-color:rgba(200,228,143,0.8)";
          //menu = [{ text: 'All team users', command: 'allusers' }, { text: 'Team task status', command: 'teamtaskstatus' }, { text: 'Team work load', command: 'teamworkload' }, { text: 'Team time done', command: 'teamtime' }, { text: 'Manage users', command: 'manageteam' },]
        }
        else if (type == "project") {
          color = "rgba(200,228,143,0.8)";
          bgStyle = "background-color:rgb(16 132 225)";
        }
        else if (type == "status") {
          color = "rgba(131,189,166,0.8)";
          bgStyle = "background-color:rgba(131,189,166,0.8)";
        }
        else if (type == "priority") {
          color = "rgba(173,207,220,0.8)";
          bgStyle = "background-color:rgba(173,207,220,0.8)";
          //icon = "/images/filter_icons/icon-priority.png";
        }
        else if (type == "date") {
          color = "rgba(122,176,197,0.8)";
          bgStyle = "background-color:rgba(122,176,197,0.8)";
        }
        else if (type == "contact") {
          color = "rgba(18,174,245,0.8)";
          bgStyle = "background-color:rgba(18,174,245,0.8)";
        }        
        else if (type == "procedure") {
          color = "rgba(248,220,211,0.8)";
          bgStyle = "background-color:rgba(248,220,211,0.8)";
          //icon = "/images/filter_icons/icon-location.png";
        }
        else if (type == "newuser") {
          color = "rgba(248,220,211,0.8)";
          bgStyle = "background-color:rgba(248,220,211,0.8)";
          //icon = "/images/filter_icons/icon-location.png";
        }
        var buttonData =
        {
          colr: color,
          customstyle: bgStyle,
          customclass: "",
          abbreviation: getAbbreviation(text),//this.GetAbbreviation(text),
          data: data,
          icon: icon,
          text: getShortName(text),//this.GetShortName(text),
          menu: menu
        };
        this.addButton(type, buttonData)
      },
      //GetShortName(longname) {
      //  var tmpName = "";
      //  var nameArr = longname.split(' ');
      //  tmpName = nameArr[0];
      //  for (var i = 1; i < nameArr.length; i++) {
      //    tmpName += " " + nameArr[i].substring(0, 1) + ".";
      //  }
      //  //tmpName = tmpName.toUpperCase();
      //  return tmpName;
      //},
      //GetAbbreviation(longname) {
      //  var nameArr = longname.split(' ');
      //  var abbreviation = "";
      //  for (var i = 0; i < nameArr.length; i++) {
      //    abbreviation += nameArr[i].substring(0, 1);
      //  }
      //  abbreviation = abbreviation.toUpperCase();
      //  return abbreviation;
      //},
      filterLocations() {
        var visibleItems = 0;
        for (var i = 0; i < this.locations.length; i++) {
          if ((this.locationFilter != null && this.locationFilter != "" && this.locations[i].text.toLowerCase().indexOf(this.locationFilter.toLowerCase()) == -1) || visibleItems > this.defaultdisplay) {
            this.locations[i].display = false;
          }
          else {
            this.locations[i].display = true;
            visibleItems++;
          }
        }
        Vue.set(this, "locations", this.locations);
      },
      filterShifts() {
        var visibleItems = 0;
        for (var i = 0; i < this.shifts.length; i++) {
          if ((this.shiftFilter != null && this.shiftFilter != "" && this.shifts[i].text.toLowerCase().indexOf(this.shiftFilter.toLowerCase()) == -1) || visibleItems > this.defaultdisplay) {
            this.locations[i].display = false;
          }
          else {
            this.shifts[i].display = true;
            visibleItems++;
          }
        }
        Vue.set(this, "shifts", this.shifts);
      },
     
      filterProcedures() {
        var visibleItems = 0;
        for (var i = 0; i < this.procedures.length; i++) {
          if ((this.procedureFilter != null && this.procedureFilter != "" && this.procedures[i].text.toLowerCase().indexOf(this.procedureFilter.toLowerCase()) == -1) || visibleItems > this.defaultdisplay) {
            this.procedures[i].display = false;
          }
          else {
            this.procedures[i].display = true;
            visibleItems++;
          }
        }
        Vue.set(this, "procedures", this.procedures);
      },
     

      filterUsers() {
        var visibleItems = 0;
        for (var i = 0; i < this.users.length; i++) {
          if ((this.userFilter != null && this.userFilter != "" && this.users[i].text.toLowerCase().indexOf(this.userFilter.toLowerCase()) == -1) || visibleItems > this.defaultdisplay) {
            this.users[i].display = false;
          }
          else {
            this.users[i].display = true;
            visibleItems++;
          }
        }
        Vue.set(this, "users", this.users);
      },
      filterTeams() {
        var visibleItems = 0;
        for (var i = 0; i < this.teams.length; i++) {
          if ((this.teamFilter != null && this.teamFilter != "" && this.teams[i].text.toLowerCase().indexOf(this.teamFilter.toLowerCase()) == -1) || visibleItems > this.defaultdisplay) {
            this.teams[i].display = false;
          }
          else {
            this.teams[i].display = true;
            visibleItems++;
          }
        }
        Vue.set(this, "teams", this.teams);
      },
     
      getdisplay(item) {
        if (item.display == true) {
          return "display:block";
        }
        return "display:none;"
      },
      async loadTeamUsers(team) {
        try {

          this.$http.get('/api/Team/GetTeamMembersFromName?name=' + team).then(async response => {
            for (var i = 0; i < response.data.length; i++) {
              var member = response.data[i];
              this.addFilterButton('user', member.Name, member.FullName);
            }
          });
        } catch (err) {
          alert('some error:' + err)
        }
      },
    },
    computed: {

    },
    mounted() {
      this.$on('remove', function (id) {
        var child = document.getElementById(id);
        child.remove();
      });

      //this.loadLocations();
      //this.loadTeams();     
      //this.loadShifts();
      this.handleRefresh();
    },

    created: function () {

    },

    watch: {

    },
    created() {
      //this.$root.$on('procedure_refresh', this.handleRefresh);
    },
  };

</script>

<style scoped>

  .filter-badge {
    line-height: 10px;
  }

  .filter-badge {
    position: absolute;
    top: -5px;
    right: 0px;
  }

  .newplus-button {
    color: #666;
    background-color: white !important;
    margin-top: 16px;
    margin-left: 5px;
  }

    .newplus-button img {
      width: 60px;
      height: 60px;
      margin-top: 5px;
    }

  .button-icon {
    width: 60px;
    height: 60px;
  }



  .btn-outline:not(.disabled):not(:disabled):not([class*="alpha-"]):hover, .newplus-button i:hover, .newplus-button i:active, .newplus-button i:focus {
    color: #000 !important;
  }

  .mobile-submenu {
    left: 0px !important;
  }

  @media (min-width: 768px) {

    .button-icon {
      width: 80px;
      height: 80px;
    }

    .mobile-submenu {
      left: 100% !important;
      position: absolute !important;
    }


    .newplus-button {
      border-color: white !important;
      background-color: white !important;
      margin-left: 17px;
      margin-top: -4px !important;
    }
  }

  .expanded-container-collapsed {
    opacity: 0;
    width: 0px;
    height: 0px;
  }

  .expanded-container-active {
    opacity: 1;
    width: 100%;
    height: 200px;
    background-color: green;
    /*
    transition: width 1s ease-out, height 1s ease-out, opacity 1s ease-out;
    -webkit-transition: width 1s ease-out, height 1s ease-out, opacity 1s ease-out;
    -moz-transition: width 1s ease-out, height 1s ease-out, opacity 1s ease-out;
    -o-transition: width 1s ease-out, height 1s ease-out, opacity 1s ease-out;
    transition: width 1s ease-out, height 1s ease-out, opacity 1s ease-out;*/
  }

  /*
  .childComponentContainer .configurator {
    margin-left: 15px !important;
  }

  .childComponentContainer .configurator:nth-child(0) {
    margin-left: 0px !important;
  }
  */
  @media screen and (max-width:768px) {

    .newplus-button img {
      width: 46px;
      height: 46px;
      margin-top: 10px;
      margin-right: 14px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/filter/filter-container-mini.vue